<template>
  <sweet-modal
    overlay-theme="dark"
    enable-mobile-fullscreen
    ref="selectVaultFileModal"
    @open="modalOpen"
    :width="$mq != 'mobile' ? '90%' : ''"
  >
    <div>
      <p class="font-medium text-xl">Select Files from Vault</p>
      <form class="my-4 flex flex-col" @submit.prevent="search">
        <div class="flex">
          <input
            type="text"
            placeholder="Search Documents"
            class="w-full border px-4 py-2 rounded-tl rounded-bl"
            v-model="query"
          />
          <button
            type="submit"
            class="px-4 py-2 bg-brand border-brand rounded-tr rounded-br text-white"
          >
            <i class="fa fa-search"></i>
          </button>
        </div>
        <div class="flex justify-between mt-4">
          <div class="flex" v-if="$mq != 'mobile'">
            <div
              v-for="tag in selectedTags"
              :key="tag.id"
              class="border border-grey py-1 px-3 text-brand rounded text-sm hover:bg-brand hover:border-brand hover:text-white mr-2 self-center flex justify-between items-center"
            >
              <span class="mr-2">
                {{ tag.name }}
              </span>
              <button type="button" class="focus:outline-none" @click="removeTagFilter(tag)">
                <i class="fas fa-times self-center"></i>
              </button>
            </div>
          </div>
          <button
            type="button"
            class="border border-brand py-2 px-4 rounded font-medium text-sm hover:bg-brand hover:text-white group"
            @click="tagSelection = !tagSelection"
          >
            <i
              class="fas fa-tags group-hover:text-white"
            ></i>
            <span v-if="selectedTags.length != 0"
              >{{ selectedTags.length }} Tag Selected</span
            >
            <span v-else>Select Tag</span>
          </button>
        </div>
        <div class="flex flex-col md:flex-row justify-center border border-grey-light rounded pb-4 mt-4" v-if="tagSelection">
          <div
            v-for="category in categorized_tags"
            :key="category.id"
            class="flex flex-col mx-4 sm:mx-2"
          >
            <p class="block uppercase my-8 text-brand font-medium text-lg h-8">
              {{ category.name }}
            </p>
            <button
              v-for="tag in category.tags"
              :key="tag.id"
              type="button"
              class="rounded w-full border text-sm font-medium py-2 px-3 my-1 hover:border-brand text-grey-darker border-grey"
              :class="{ 'bg-brand text-white border-brand': isSelected(tag) }"
              @click="selectTag(tag)"
            >
              {{ tag.name }}
            </button>
          </div>
        </div>
      </form>
      <div
        class="text-center text-xl p-8 flex justify-center items-center bg-grey-light h-64"
        v-if="searching"
      >
        <i class="fa fa-circle-notch fa-spin"></i>
        <span class="ml-2">Searching...</span>
      </div>
      <div class="flex h-full overflow-x-auto" v-else-if="files.length > 0">
        <select-vault-file
          v-for="file in files"
          :key="file.id"
          :file="file"
          @file-checked="fileChecked"
        ></select-vault-file>
      </div>
      <div
        class="text-center text-xl p-8 flex justify-center items-center bg-grey-light h-64"
        v-else
      >
        <span class="ml-2">No results found</span>
      </div>
      <button
        class="bg-brand py-3 px-6 mx-2 text-white rounded font-medium mt-4 hover:bg-brand-dark"
        :class="{ 'opacity-50': selectedFile.length == 0 }"
        :disabled="selectedFile.length == 0"
        @click="selectFiles"
      >
        <i class="fa fa-folder-open"></i>
        Select {{ selectedFileCount }} Files
      </button>
    </div>
  </sweet-modal>
</template>

<script>
import { mapGetters } from "vuex";
import SelectVaultFile from "./SelectVaultFile.vue";

export default {
  name: "SelectVaultFileModal",
  components: {
    SelectVaultFile,
  },
  data() {
    return {
      searching: true,
      query: "",
      files: [],
      selectedFile: [],
      selectedTags: [],
      tagSelection: false,
      abortController: null,
    };
  },
  computed: {
    selectedFileCount() {
      if (this.selectedFile.length > 0) {
        return `(${this.selectedFile.length})`;
      }
      return "";
    },
    ...mapGetters({
      categorized_tags: "getCategorizedTags",
    }),
  },
  methods: {
    search() {
      this.tagSelection = false;
      this.getVaultFiles();
    },
    removeTagFilter(tag) {
      this.selectTag(tag);
      this.getVaultFiles();
    },
    selectTag(tag) {
      if (!this.isSelected(tag)) {
        this.selectedTags.push(tag);
        return;
      }
      this.selectedTags = this.selectedTags.filter((t) => t.id != tag.id);
    },
    isSelected(tag) {
      return this.selectedTags.find((t) => t.id == tag.id);
    },
    modalOpen() {
      this.getVaultFiles();
    },
    selectFiles() {
      if (this.selectedFile.length == 0) {
        this.$noty.warning("No file selected");
        return;
      }
      this.$emit("selected-vault-files", this.selectedFile);
      this.selectedFile = [];
    },
    fileChecked(payload) {
      const { checked, file } = payload;
      if (checked) {
        const isFileExist = this.selectedFile.find((f) => f.id == file.id);
        if (!isFileExist) {
          this.selectedFile = [...this.selectedFile, file];
        }
      } else {
        const isFileExist = this.selectedFile.find((f) => f.id == file.id);
        if (isFileExist) {
          const filtered = this.selectedFile.filter((f) => f.id != file.id);
          this.selectedFile = [...filtered];
        }
      }
      this.$emit("selected-file", this.selectedFile);
    },
    getVaultFiles() {
      this.searching = true;

      if(this.abortController) {
        this.abortController.abort();
      } 

      this.abortController = new AbortController();

      axios
        .get(`/api/vaults/${this.$route.params.vault_id}/files`, {
          params: {
            query: this.query,
            filled_only: 0,
            tags: this.selectedTags.map((tag) => tag.id),
          },
          signal: this.abortController.signal
        })
        .then((res) => {
          this.files = res.data;
        })
        .finally(() => {
          this.searching = false;
        });
    },
  },
};
</script>

